import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import * as React from 'react'
import { useCancelIssues } from '../../../APIs/Hooks/LimsHooks'

function ConfirmCancelItemsDialog({
  open,
  setOpen,
  items,
}: {
  open: string | undefined
  setOpen: any
  items: number[]
}) {
  const { mutate: cancelIssue } = useCancelIssues(setOpen, items)
  return (
    <Dialog
      aria-label={'Confirm Cancel Dialog'}
      open={open === 'cancel_items'}
      onClose={() => setOpen(undefined)}
    >
      <DialogTitle>{`Are you sure you wish to cancel ${items.length} item(s) on this order?`}</DialogTitle>
      <DialogActions>
        <Button
          onClick={() => setOpen(undefined)}
          color="error"
        >
          No, Close
        </Button>
        <Button
          onClick={() => cancelIssue()}
          color="warning"
        >
          Yes, Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmCancelItemsDialog
